module.exports = __webpack_public_path__ + "img/Quickbooks@2x.fed0791e.png";